import { render, staticRenderFns } from "./AddNewUser.vue?vue&type=template&id=a7370a30&"
import script from "./AddNewUser.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddNewUser.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AddNewUser.vue?vue&type=style&index=0&id=a7370a30&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports